import { render, staticRenderFns } from "./app-notifications.vue?vue&type=template&id=321cdc61&"
import script from "./app-notifications.vue?vue&type=script&lang=js&"
export * from "./app-notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('321cdc61')) {
      api.createRecord('321cdc61', component.options)
    } else {
      api.reload('321cdc61', component.options)
    }
    module.hot.accept("./app-notifications.vue?vue&type=template&id=321cdc61&", function () {
      api.rerender('321cdc61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/usermgmt/app-notifications.vue"
export default component.exports